import { postForm } from '@/shared/api/client';
import { getListRows } from '@/shared/lib/pagination';

export interface PlaceItem extends Record<string, unknown> {
  id: string | number;
  name?: string;
}

/** Active countries only (legacy `getCountries(token, 0)`). */
export async function fetchActiveCountries() {
  const res = await postForm<Record<string, unknown>>('/place/country/list/', {
    page: 0,
    limit: 10000,
    is_active: 1,
  });
  return getListRows<PlaceItem>(res, ['countries', 'items']);
}
